module.exports = __webpack_public_path__ + "static/cradle-to-cradle-4697aad2da2f0e951fe04315e7c9968c.jpg";